import {createActionGroup, emptyProps} from '@ngrx/store';
import {CarouselDisplay, CATALOG_FEATURE_KEY, CatalogRecord, CatalogRecordAvailabilityDetail} from '@store/catalog/catalog.types';
import {ListData} from '@aviary/store/common/common.types';

export const CatalogActions = createActionGroup({
  source: CATALOG_FEATURE_KEY,
  events: {
    'Load Catalog Record': (id: number) => ({id}),
    'Load Catalog Record Success': (catalogRecord: CatalogRecord) => ({catalogRecord}),
    'Load Catalog Record Failure': (error: unknown) => ({error}),
    'Load Catalog Availability': (id: number) => ({id}),
    'Load Catalog Availability Success': (availability: CatalogRecordAvailabilityDetail) => ({availability}),
    'Load Catalog Availability Failure': (error: unknown) => ({error}),
    'Load Catalog Related Items': (id: number) => ({id}),
    'Load Catalog Related Items Success': (relatedItems: CatalogRecord[]) => ({relatedItems}),
    'Load Catalog Related Items Failure': (error: unknown) => ({error}),

    'Load Catalog Carousels': emptyProps(),
    'Load Catalog Carousels Success': (listData: CarouselDisplay[]) => ({listData}),
    'Load Catalog Carousels Failure': (error: unknown) => ({error}),

    'Search Catalog': emptyProps(),
    'Search Catalog Success': (listData: ListData<CatalogRecord>) => ({listData}),
    'Search Catalog Failure': (error: unknown) => ({error}),

    'Load Favorites': emptyProps(),
    'Load Favorites Success': (listData: ListData<CatalogRecord>) => ({listData}),
    'Load Favorites Failure': (error: unknown) => ({error}),

    'Load Favorites Ids': emptyProps(),
    'Load Favorites Ids Success': (ids: number[]) => ({ids}),
    'Load Favorites Ids Failure': (error: unknown) => ({error}),

    'Add Favorite': (catalogRecordId: number) => ({catalogRecordId}),
    'Add Favorite Failure': (error: unknown) => ({error}),

    'Remove Favorite By Catalog Record Id': (catalogRecordId: number) => ({catalogRecordId}),
    'Show Remove Favorite': (favorite: CatalogRecord, reloadIdsOnly: boolean = false) => ({favorite, reloadIdsOnly}),
    'Remove Favorite': (catalogRecordId: number, reloadIdsOnly: boolean) => ({catalogRecordId, reloadIdsOnly}),
    'Remove Favorite Failure': (error: unknown) => ({error}),

    'Show All Filter Options': (filterName: string, filterDisplayName: string) => ({filterName, filterDisplayName})
  },
});
